import React from 'react';
import { Main } from 'fragments';
import { TermsAndConditionsFragment } from './fragments';

export const TermsAndConditions = () => {
    return (
        <Main>
            <TermsAndConditionsFragment />
        </Main>
    );
};
